import ChevronDownIcon from '@atlaskit/icon/glyph/chevron-down';
import ChevronUpIcon from '@atlaskit/icon/glyph/chevron-up';
import React from 'react';

export type ChrevronProps = {
  readonly isOpen: boolean;
};

export function Chevron({ isOpen }: ChrevronProps) {
  if (isOpen) {
    return <ChevronUpIcon label="Hide" size="small" />;
  } else {
    return <ChevronDownIcon label="Show" size="small" />;
  }
}
